import { Outlet } from "react-router-dom";
import { FormDirtyProvider } from "shared/src/hooks/use-form-dirty-context";
import { NavigationBlocker } from "shared/src/components/navigation-blocker";

export function FormDirtyLayout() {
  return (
    <FormDirtyProvider>
      <NavigationBlocker />
      <Outlet />
    </FormDirtyProvider>
  );
}
